<div mat-dialog-content>
    <div class="qrcodeImage qr-modal">
        <qrcode [qrdata]="qrInfo" [width]="500" [errorCorrectionLevel]="'M'" [cssClass]="'demoBorder'"></qrcode>
    </div>
</div>

<div mat-dialog-actions class="qr-dialog-actions">
    <button mat-raised-button color="primary" (click)="abrirWp()">Compartir por whatsapp</button>
    <button mat-raised-button color="accent" (click)="descargar()">Descargar</button>
</div>
